var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupees(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 42.7 14 28v-4h7.15q2.5 0 4.45-1.5 1.95-1.5 2.3-4.35H11.5V14.2h16.3q-.55-2.2-2.525-3.575Q23.3 9.25 21 9.25h-9.5v-4h25v4h-7.45q1 .8 1.775 2.275Q31.6 13 31.95 14.2h4.55v3.95h-4.55q-.5 4.5-3.425 7.1-2.925 2.6-6.925 2.7h-2.15L33.5 42.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupees);
export default __webpack_public_path__ + "static/media/rupees.3da73030ddeb9bc2284cea1cd6d0e6fe.svg";
export { ForwardRef as ReactComponent };